const lang = {
	EN: {
		headerTitile: 'Basket',
		tosumm: 'FOR THE AMOUNT',
		confpromocode: 'apply code',
		addpromo: 'discount promo code',
		promocode: 'Promo code',
		errpromo: 'Promo code not found or not available',
		itogo: 'TOTAL',
		salepromo: 'Discount using promo code',
		confzakaz: 'CHECKOUT',
		notBasker: 'Nothing has been added to cart yet',
		colortile: 'COLOR',
		remove: 'delete',
		size: 'SIZE',
		r: '₽'
	},

	'': {
		headerTitile: 'Корзина',
		tosumm: 'НА СУММУ',
		confpromocode: 'применить код',
		addpromo: 'промокод на скидку',
		promocode: 'Промокод',
		errpromo: 'Промокод не найден или недоступен',
		itogo: 'ИТОГО',
		salepromo: 'Скидка по промокоду',
		confzakaz: 'ОФОРМИТЬ ЗАКАЗ',
		notBasker: 'В корзину еще ничего не добавлено',
		colortile: 'ЦВЕТ',
		size: 'РАЗМЕР',
		remove: 'удалить',
		r: '₽'
	},
	KZ: {
		headerTitile: 'Себет',
		tosumm: 'СОМАСЫНА',
		confpromocode: 'кодты қолданыңыз',
		addpromo: 'жеңілдік промо коды',
		promocode: 'Промокод',
		errpromo: 'Промокод табылмады немесе қол жетімді емес',
		itogo: 'БАРЛЫҒЫ',
		salepromo: 'Промокодты пайдаланып жеңілдік',
		confzakaz: 'ШЫҒУ',
		notBasker: 'Себетке әлі ештеңе қосылмаған',
		colortile: 'ТҮС',
		remove: 'жою',
		size: 'SIZE',
		r: '₸'
	},
	ARM: {
		headerTitile: 'Զամբյուղ',
		tosumm: 'ԳՈՒՄԱՐԻ ՀԱՄԱՐ',
		confpromocode: 'կիրառել կոդը',
		addpromo: 'զեղչի պրոմո կոդը',
		promocode: 'Պրոմո Կոդ',
		errpromo: 'Պրոմո կոդը չի գտնվել կամ հասանելի չէ',
		itogo: 'ԸՆԴԱՄԵՆԸ',
		salepromo: 'Զեղչ՝ օգտագործելով պրոմո կոդը',
		confzakaz: 'ՄԱՍՆԱԳԻՐ',
		notBasker: 'Զամբյուղում դեռ ոչինչ չի ավելացվե',
		colortile: 'ԳՈՒՅՆ',
		remove: 'ջնջել',
		size: 'ՉԱՓԸ',
		r: '֏'
	}
};

export { lang };
